/** PostHog project token — empty in local dev is expected. */
export function getPostHogProjectToken(): string | undefined {
  const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN?.trim();
  return token || undefined;
}

/** Server-side analytics (API routes, OAuth callbacks). */
export function isPostHogEnabledOnServer(): boolean {
  return Boolean(getPostHogProjectToken() && process.env.NODE_ENV === 'production');
}

/** Browser client bootstrap — skip localhost and non-production. */
export function isPostHogEnabledInBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  if (!getPostHogProjectToken() || process.env.NODE_ENV !== 'production') return false;
  const host = window.location.hostname;
  return host !== 'localhost' && host !== '127.0.0.1';
}
